import { ClassAttributes, createElement, useContext } from 'react';

import Component from '../component/compound/NonFatalErrorSnackbars';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const NonFatalErrorSnackbars = ({ className }: Props) => {
  const dependency = useContext(DependencyContext);
  const state = useContext(StateContext);

  return (
    <Component
      errors={state.nonFatalErrors.toArray()}
      onRequestClose={(_: any, err: Error) => dependency.errorPresenter.removeNonFatal(err)}
      className={className}
    />
  );
};

export default NonFatalErrorSnackbars;
